import {
  ChatMessageAttributes,
  ChatUserAttributes,
} from '../../../Components/Chat/types';

export enum ReorderWorksheetActivityEnum {
  OPEN_CHAT = 'OPEN_CHAT',
  JOIN_CHAT = 'JOIN_CHAT',
  CLOSE_CHAT = 'CLOSE_CHAT',
  UPDATE_FORM = 'UPDATE_FORM',
}

export type ReorderWorksheetActivityAuthor = {
  type: 'internal' | 'vp';
  id?: string;
  name: string;
  email?: string;
};

type BaseEventParams = {
  worksheet_id?: string;
};

export type OpenChatEventParams = BaseEventParams & {
  reasons: string[];
  comment: string | null;
  author?: ReorderWorksheetActivityAuthor;
};

export type CloseChatEventParams = BaseEventParams;

// UPDATE_FORM always uses flat format: { new: Record<field, value>, old: Record<field, value> }
export type UpdateFormEventParams = BaseEventParams & {
  changes?: { new?: Record<string, unknown>; old?: Record<string, unknown> };
};

export type ReorderWorksheetActivity = {
  event_id: string;
  style_color: string;
  vendor_id: string;
  event_type: ReorderWorksheetActivityEnum;
  event_params:
    | OpenChatEventParams
    | CloseChatEventParams
    | UpdateFormEventParams;
  author: ReorderWorksheetActivityAuthor;
  created_at: string;
};

export type ReorderChatContact = {
  id: string;
  full_name: string;
  email: string;
};

export type ReorderChat = {
  vendor_id: string;
  style_color: string;
  is_active: boolean;
  fn_contacts: ReorderChatContact[];
  vendor_contacts: ReorderChatContact[];
  created_at: string;
  updated_at: string;
};

export type BackendChatMessage = {
  sid: string;
  body: string;
  attributes: ChatMessageAttributes;
  dateCreated: string;
  author?: {
    sid: string;
    identity: string;
    friendlyName: string;
    isOnline: boolean;
    attributes: ChatUserAttributes;
  };
  media?: unknown[];
};

// Type guards
export function isOpenChatActivity(
  activity: ReorderWorksheetActivity,
): activity is ReorderWorksheetActivity & {
  event_params: OpenChatEventParams;
} {
  return activity.event_type === ReorderWorksheetActivityEnum.OPEN_CHAT;
}

export function isCloseChatActivity(
  activity: ReorderWorksheetActivity,
): activity is ReorderWorksheetActivity & {
  event_params: CloseChatEventParams;
} {
  return activity.event_type === ReorderWorksheetActivityEnum.CLOSE_CHAT;
}

export function isUpdateFormActivity(
  activity: ReorderWorksheetActivity,
): activity is ReorderWorksheetActivity & {
  event_params: UpdateFormEventParams;
} {
  return activity.event_type === ReorderWorksheetActivityEnum.UPDATE_FORM;
}
